import React from 'react'
import CrowdStrikeSpotlightCredentialsForm from './CrowdStrikeSpotlightCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils';
import CrowdStrikeFalconMappingForm, { SCAN_TYPE_OPTIONS } from './CrowdStrikeFalconMappingForm';
import { find, isFunction, map, split, isNull } from 'utils/lodashUtils';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

export default function CrowdStrikeSpotlightConfigListing(props) {
    const featureFlags = useFeatureFlag()
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraColumns={getFalconColumns(featureFlags)}
            MappingForm={CrowdStrikeFalconMappingForm}
            CredentialsForm={CrowdStrikeSpotlightCredentialsForm}
            triggerModifyParam={triggerModifyParam}
        />
    )
};

const getFalconColumns = (featureFlags) => [{
    title: "Scan Type",
    dataIndex: "type",
    width: 120,
    render: (type, record) => type === "cloudProvider" ? "CSPM" : find(SCAN_TYPE_OPTIONS, scanType => scanType.value === type)?.label,
    filterLabelFormatter: (type, record) => type === "cloudProvider" ? "CSPM" : find(SCAN_TYPE_OPTIONS, scanType => scanType.value === type)?.label,
}, {
    title: "Tag Value",
    dataIndex: "tagValues",
    width: 120,
    render: (tagValues) => isNull(tagValues) ? CellRenderers.VALUE_OR_NA() : tagValues === ""  ? "All" :  split(tagValues, ",").join(", "),
  }, 
  {
      title: "Host Groups",
      dataIndex: "hostGroupNames",
      width: 120,
      render: (hostGroupNames) => isNull(hostGroupNames) ? CellRenderers.VALUE_OR_NA() : hostGroupNames === ""  ? "All" :  columnRenderArrayData(hostGroupNames),
  }, 
  {
    title: "Cluster With NameSpaces",
    dataIndex: "clusterWithNamespace",
    width: 240,
    render: (clusterWithNamespace, record) => {
      if (record.type === "kubernetes") {
        const formatClusterIDtoName = (clusterID, index) => record.clusterName ? split(record.clusterName, ",")[index] : clusterID;
        return renderMultipleDependentValues(clusterWithNamespace, formatClusterIDtoName);
      }
      return CellRenderers.VALUE_OR_NA();
    },
  },
  {
    title: "Cloud Provider With Accounts",
    dataIndex: "cloudProviderWithAccountsName",
    width: 200,
    render: (cloudProviderWithAccountsName, record) => {
      if(record.type === "cloudProvider"){
        return renderMultipleDependentValues(cloudProviderWithAccountsName)
      }
      return CellRenderers.VALUE_OR_NA()
    }
  },
  ...(!featureFlags.ENABLE_CONTAINER_DETAIL_WITHOUT_REGISTRY_CROWDSTRIKE ? [{
    title: "Image Registry With Repositories",
    dataIndex: "registry",
    width: 200,
    render: (registry, record) => {
      if (record.type === "images") {
        return columnRenderArrayData(
          map(split(registry, ","), (reg, index) => {
            const repositoryArray = split(
              split(record.repository, ";")[index],
              ","
            );
            return repositoryArray.map((multipleValues) => {
              return `${reg} - ${multipleValues}`;
            });
          }).join()
        );
      }
      return CellRenderers.VALUE_OR_NA();
    },
  }] : [{
    title: "Image Repositories",
    dataIndex: "repository",
    width: 200,
    render: (repository, record) => {
      if (record.type === "images") {
        return columnRenderArrayData(repository);
      }
      return CellRenderers.VALUE_OR_NA();
    },
  }])
];


const renderMultipleDependentValues = (dependentValue, formatKey) => {
  return columnRenderArrayData(
    map(split(dependentValue, ","), (pair, index) => {
      const [key, values] = pair.split("|:");
      const result = values?.split(";");
      return result
        ? result.map(
            (multipleValues) => {
              const formattedKey = isFunction(formatKey) ? formatKey(key, index) : key;
              return `${formattedKey} ${multipleValues ? `- ${multipleValues === "all" ? "All" : multipleValues}` : ""}`
            }
          )
        : key;
    }).join()
  );
};

const triggerModifyParam = (record) => {
  return {
      toolConfigId: record.id
  }
}